import { c as _c } from "react/compiler-runtime";
import { Box, Color, Text, Tokens } from "@chakra-ui/react";
interface PillProps {
  exists: boolean | undefined;
  trueData: string | string[];
  falseData: string;
  noData: string;
  variant?: "pill" | "reverse";
  pillBackgroundColor?: Tokens["colors"]; // optional prop to set the background color of the pill
}
const Pill: React.FC<PillProps> = t0 => {
  const $ = _c(14);
  const {
    exists,
    trueData,
    falseData,
    noData,
    variant: t1,
    pillBackgroundColor
  } = t0;
  const variant = t1 === undefined ? "pill" : t1;
  let t2;
  if ($[0] !== exists || $[1] !== pillBackgroundColor) {
    const getColor = () => {
      if (pillBackgroundColor) {
        return pillBackgroundColor;
      }
      switch (exists) {
        case true:
          {
            return "orange.600/90";
          }
        case false:
          {
            return "green";
          }
        default:
          {
            return "muted";
          }
      }
    };
    t2 = getColor();
    $[0] = exists;
    $[1] = pillBackgroundColor;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const color = t2;
  let t3;
  if ($[3] !== exists || $[4] !== falseData || $[5] !== noData || $[6] !== trueData) {
    const getLabel = () => {
      switch (exists) {
        case true:
          {
            return trueData;
          }
        case false:
          {
            return falseData;
          }
        default:
          {
            return noData;
          }
      }
    };
    t3 = getLabel();
    $[3] = exists;
    $[4] = falseData;
    $[5] = noData;
    $[6] = trueData;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const label = t3;
  const t4 = variant === "reverse" ? pillBackgroundColor : color;
  const t5 = variant === "reverse" ? "black" : "white";
  const t6 = variant === "reverse" ? "xs" : "none";
  const t7 = variant === "reverse" ? "black" : "transparent";
  let t8;
  if ($[8] !== label || $[9] !== t4 || $[10] !== t5 || $[11] !== t6 || $[12] !== t7) {
    t8 = <Box><Text bgColor={t4} color={t5} py="0.5" px="3" borderRadius="full" border={t6} borderColor={t7} whiteSpace="nowrap">{label}</Text></Box>;
    $[8] = label;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
};
export default Pill;